<script>
  import { customUserStore } from "./stores/user_store.js";


  let credentials = { username: "", password: "" };

  function tryLogin() {
    if (credentials.username && credentials.password) {
      customUserStore.doLogin(credentials);
    }
  }

    function changed(e) {
    if (e.keyCode == 13) {
      tryLogin();
    }
  }


</script>

<style>
  input {
    width: 70px;
  }


span.link {
  cursor: pointer;
}

</style>
<table>
<tr>
<td>
  Benutzer
</td>
<td>
  <input
    id="user"
    type="text"
    bind:value={credentials.username}
    on:keyup={changed}
    add:autofocus
    add:autoselect />
</td>
</tr>
<tr>
<td>
  Passwort
</td>
<td>
  <input type="password" bind:value={credentials.password} on:keyup={changed} />
</td>
</tr>
<tr>
<td>
</td>
<td>
          <span class="link" on:click={tryLogin}>[anmelden]</span>
</td>
</tr>
</table>
        